import InputMask from "react-input-mask";

export default function PhoneInput({
  id,
  value,
  onChange,
  onBlur,
  onFocus,
  error,
  required,
  disabled,
  className,
  countryCode,
  touched,
  ...props
}) {
  const placeholder = countryCode === "TR" ? "(5__) ___ ____" : "_____________";
  const mask = countryCode === "TR" ? "(999) 999 9999" : "9999999999999";
  return (
    <InputMask
      key={countryCode}
      mask={mask}
      value={value}
      disabled={disabled}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      maskChar="_"
    >
      {(inputProps) => (
        <input
          {...inputProps}
          id={id}
          type="text"
          required={required}
          placeholder={placeholder}
          autoComplete="tel"
          disabled={disabled}
          className={`h-[50px] text-gray-700 text-sm w-full px-3 border rounded-lg focus:outline-none focus:ring-1 focus:ring-red-500
            ${
              touched && error
                ? "outline-none ring-1 ring-red-500"
                : "border-gray-300"
            } ${className}`}
          {...props}
        />
      )}
    </InputMask>
  );
}
